import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 选择班次
import SelectSch from './select-scheduling';
// 选择周期
import settingScheduling from './setting-scheduling';
// 选择人员
import SelectPerson from './select-person.vue';
// 选择开始月份 生成表格
import SelectDate from './select-date.vue';
import staffSearch from '_c/staff-search';
import batchUpload from '_c/batch-upload';
import { round_info, round_add_shift, round_add_staff_shift, exportStaffShift, downloadStaffShiftTpl } from 'api/Attendance';
export default {
  components: {
    SelectSch: SelectSch,
    settingScheduling: settingScheduling,
    SelectPerson: SelectPerson,
    SelectDate: SelectDate,
    staffSearch: staffSearch,
    batchUpload: batchUpload
  },
  props: {
    p: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      form: {
        month: new Date(),
        staff_id: ''
      },
      groupId: '',
      // 考勤组id
      tableData: [],
      scheduling: [],
      // 已选班次
      roundTable: [],
      // 周期表格
      // 班次信息
      cycle: {
        groups: [],
        num: 0
      },
      pagina: {
        page: 1,
        size: 20,
        total: 0
      },
      loading: false,
      // 数据保存loading
      editGroups: [] // 编辑几项
    };
  },
  created: function created() {
    this.init();
  },
  computed: {
    // 生成日期可是key
    dateKey: function dateKey() {
      var month = this.form.month;
      if (!month) return '';
      return this.$util.parseTime(month, '{y}-{m}');
    }
  },
  methods: {
    init: function init(groupId) {
      var _this = this;
      this.groupId = groupId;
      this.$nextTick(function () {
        return _this.getRoundInfo();
      });
    },
    // 只展示俩位
    handlerSlice: function handlerSlice(str) {
      str = String(str);
      return str.slice(0, 2);
    },
    // 选择人员
    handlerSelectPerson: function handlerSelectPerson(row) {
      var msg = {
        id: this.groupId,
        cycle_id: this.cycle.id,
        group_id: row.group_id
      };
      this.$refs.selectPerson.init(msg);
    },
    handlerClass: function handlerClass(row, item) {
      var currentData = this.createData(row, item);
      if (currentData.isEdit) return 'modified';
    },
    // 单项数据修改
    handlerChangeSch: function handlerChangeSch(params) {
      var key = params.key,
        day = params.day,
        data = params.data,
        shift = params.shift;
      day = day <= 9 ? '0' + day : day;
      params.date_at = "".concat(this.dateKey, "-").concat(day);
      var target = data[params.date_at];
      if (target) {
        target.color = shift.color;
        target.name = shift.name;
        target.isEdit = true;
      }
      var status = true;
      // 去重
      this.editGroups.forEach(function (element) {
        if (element.day === params.day && element.staff_id === params.staff_id) {
          element.shift_id = params.shift_id;
          status = false;
        }
      });
      // 去重之后添加
      if (status) this.editGroups.push(params);
      this.$refs[key][0].doClose();
    },
    // 导出
    handleExport: function handleExport() {
      exportStaffShift({
        id: this.groupId,
        month: this.dateKey,
        staff_id: this.form.staff_id
      }).then(function (res) {
        window.open(res.data);
      });
    },
    openUpload: function openUpload() {
      var data = {
        title: this.$t('i18n.560e1c94a4d74e6ea0a94d6c8a3acd62'),
        list: {
          1: {
            name: this.$t('bulkImport'),
            label: '1',
            tip: this.$t('46'),
            download: this.$t('47'),
            download_text: this.$t('778'),
            download_api: downloadStaffShiftTpl,
            query: {
              id: this.groupId,
              month: this.dateKey
            },
            upload: this.$t('39'),
            upload_text: this.$t('728'),
            upload_tip: this.$t('40'),
            upload_api: '/web/attendance/updateStaffShift',
            type: '2',
            emit: true
          },
          2: {
            name: this.$t('batch_update'),
            label: '2',
            tip: this.$t('46'),
            download: this.$t('i18n.724568c9fe4a45e5839815df5b53d10e'),
            download_text: this.$t('1373'),
            download_api: exportStaffShift,
            query: {
              id: this.groupId,
              month: this.dateKey
            },
            upload: this.$t('39'),
            upload_text: this.$t('728'),
            upload_tip: this.$t('40'),
            upload_api: '/web/attendance/updateStaffShift',
            type: '2',
            emit: true
          }
        }
      };
      this.$refs.batchUpload.init(data);
    },
    doSubmit: function doSubmit() {
      this.getRoundInfo();
    },
    // 搜索人员
    staffChange: function staffChange(val) {
      this.form.staff_id = val.staff_id;
      this.getRoundInfo();
    },
    // 生成考勤日历
    handlerCreateDate: function handlerCreateDate() {
      // 如果是当前月则切换到当前天 反之为每月一号
      var month = new Date().getMonth();
      if (month === this.form.month.getMonth()) this.form.month = new Date();
      this.$refs.selectDate.init({
        id: this.groupId,
        date: this.form.month
      });
    },
    // 按天排班恢复
    handlerDayCancel: function handlerDayCancel() {
      this.editGroups = [];
      this.getRoundInfo();
    },
    // 按天排班保存
    handlerDaySave: function handlerDaySave() {
      var _this2 = this;
      var msg = {
        id: this.groupId,
        // 考勤组id
        data: this.editGroups
      };
      this.loading = true;
      round_add_staff_shift(msg).then(function () {
        _this2.editGroups = [];
        _this2.getRoundInfo();
      }).finally(function () {
        return _this2.loading = false;
      });
    },
    // 表格文案
    createData: function createData(row, item) {
      return row["".concat(this.dateKey, "-").concat(item.day < 10 ? '0' + item.day : item.day)];
    },
    // 单元格颜色
    cellStyle: function cellStyle(params) {
      var columnIndex = params.columnIndex,
        row = params.row;
      var data = row[columnIndex];
      if (data && data.color) return {
        background: data.color,
        color: '#FFFFFF'
      };
    },
    // 日历单元格颜色
    dateCellStyle: function dateCellStyle(params) {
      var columnIndex = params.columnIndex,
        row = params.row;
      var keyIndex = this.tableData.days[columnIndex - 1];
      if (keyIndex && keyIndex.day) {
        var currentData = this.createData(row, keyIndex);
        if (currentData && currentData.color) {
          return {
            background: currentData.color,
            color: '#FFFFFF'
          };
        }
      }
    },
    // 获取排班详情
    getRoundInfo: function getRoundInfo() {
      var _this3 = this;
      if (!this.dateKey) return;
      var query = _objectSpread({
        id: this.groupId,
        month: this.dateKey
      }, this.pagina);
      if (this.form.staff_id) query.staff_id = this.form.staff_id;
      round_info(query).then(function (res) {
        var data = res.data;
        _this3.cycle = data.cycle;
        _this3.scheduling = data.shifts;
        _this3.tableData = data.staffs;
        _this3.pagina.total = data.staffs.count;
      });
    },
    // 分页相关
    handleSizeChange: function handleSizeChange(val) {
      this.pagina.page = 1;
      this.pagina.size = val;
      this.getRoundInfo();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagina.page = val;
      this.getRoundInfo();
    },
    // 选择班次弹窗开启
    selectSchOpen: function selectSchOpen() {
      this.$refs.selectSch.init(null, true, this.scheduling);
    },
    // 日期选择限制
    // disabledDate(t) {
    //   return t.getMonth() < month
    // },
    // change添加
    schSelect: function schSelect(data) {
      var _this4 = this;
      this.scheduling = data;
      round_add_shift({
        id: this.groupId,
        shift_ids: data.map(function (item) {
          return item.id;
        })
      }).then(function () {
        _this4.getRoundInfo();
      });
    }
  }
};